import Heading, {
  HeadingTag,
} from "immigram-ui-cmon/src/components/Heading/Heading";
import Paragraph from "immigram-ui-cmon/src/components/Paragraph/Paragraph";
import { useTranslation } from "next-i18next";
import React from "react";
import { Control } from "react-hook-form";

import { ValidationError } from "@/lib/hook/useValidation";

import ControlledCheckboxListWithRaisingLabel from "@/components/FormElements/ControlledCheckboxListWithRaisingLabel";

import {
  ConfigParamValueWithModifiers,
  getModifiedConfigParamValue,
  ImmigramFormElementConfigBase,
  ImmigramFormElementOnChange,
  ImmigramFormElementType,
} from "./common";

export interface ImmigramFormElementConfigCheckbox
  extends ImmigramFormElementConfigBase {
  type: ImmigramFormElementType.Checkbox;
  name: string;
  title?: ConfigParamValueWithModifiers;
  description?: ConfigParamValueWithModifiers;
  options: {
    value: string;
    title?: ConfigParamValueWithModifiers;
    group?: ConfigParamValueWithModifiers;
    description?: ConfigParamValueWithModifiers;
  }[];
}

interface ImmigramFormCheckboxProps {
  elementConfig: ImmigramFormElementConfigCheckbox;
  control: Control;
  onChange: ImmigramFormElementOnChange;
  disabled: boolean;
  validationErrors?: ValidationError | null;
}

function ImmigramFormCheckbox({
  elementConfig,
  control,
  onChange,
  disabled,
  validationErrors,
}: ImmigramFormCheckboxProps) {
  const { t } = useTranslation();

  const title = getModifiedConfigParamValue(t, elementConfig.title);
  const description = getModifiedConfigParamValue(t, elementConfig.description);

  return (
    <>
      {title && (
        <Heading tag={HeadingTag.H6} className="mt-0 mb-2">
          {title}
        </Heading>
      )}
      {description && (
        <Paragraph className="mt-0 mb-2">{description}</Paragraph>
      )}
      <ControlledCheckboxListWithRaisingLabel
        control={control}
        fieldName={elementConfig.name}
        options={elementConfig.options.map(
          ({ value, title, description, group }) => ({
            title: getModifiedConfigParamValue(t, title),
            value,
            subTitle: getModifiedConfigParamValue(t, description),
            group: getModifiedConfigParamValue(t, group, {
              forceText: true,
            }) as string,
          })
        )}
        onChange={onChange}
        disabled={disabled}
        error={validationErrors?.message}
      />
    </>
  );
}

export { ImmigramFormCheckbox };
